module.exports = __webpack_public_path__ + "./fonts/Roboto_medium.ttf";